import React, {useEffect, useMemo} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';

import {IStore} from 'redux/interface';

import Loader from 'components/loader';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {Pages, TranslationKeys} from '../../utils/constants/routeConstants';
import {
  activitiesAsyncActions,
  getActivities,
  getTranslations
} from '../../redux/pageAsyncActions';

import XpeditionIcon from 'assets/image/menu-auth/xpedition.png';
import {ActivityCard} from '../../components/activity-card/ActivityCard';
import NotFoundImg from '../../assets/image/common/notFound.png';
import NotFoundInfo from '../../components/not-found-info';

import './styles.scss';
import {closeArticle} from '../../redux/content/actions';
import {dialogueClearedAction} from '../../redux/dialogue/actions';

export const Activities: React.FC = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const {activities} = useSelector((state: IStore) => state.activities);
  const {settings} = useSelector((state: IStore) => state.auth);
  const {loading} = useSelector((state: IStore) => state.status);
  const [filter, setFilter] = React.useState('all');

  const pageConfig = useMemo(() => {
    return settings?.pages.find(
      (p) => p.name.toLowerCase() === Pages.Activities.toLowerCase()
    );
  }, [settings]);

  const translationKey = pageConfig?.translationKey || TranslationKeys.Activities;
  const title = pageConfig?.title || Pages.Activities;

  useGetTranslations({translationKey});

  useEffect(() => {
    dispatch(activitiesAsyncActions[getActivities]());
  }, [dispatch]);

  useEffect(() => {
    dispatch(closeArticle());
    dispatch(dialogueClearedAction());
  }, []);

  const isTranslationsLoading = loading.includes(getTranslations);
  const isActivitiesLoading = loading.includes(getActivities);

  const filtered = activities.filter(a => {
    if (filter === 'completed') {
      return a.percentage === 100;
    }
    if (filter === 'in_progress') {
      return !!a.dialogId;
    }

    return true;
  });

  if (isTranslationsLoading) {
    return <Loader nested />;
  }

  return (
    <section className="activities container">
      <h1 className="activities__title">
        <img src={XpeditionIcon} alt="" className="activities__icon" />
        <FormattedMessage
          id={`gritx.common.navigation.${title}`}
          defaultMessage={title}
        />
      </h1>

      {isActivitiesLoading && <div className="activities__loader">
        <Loader nested/>
      </div>}
      {!isActivitiesLoading && activities.length === 0 && <div className="activities__empty">
        <NotFoundInfo
          title={intl.formatMessage({
            id: 'gritx.activities.notFound',
            defaultMessage: 'Sorry, but nothing can be found.'
          })}
          image={NotFoundImg}
        />
      </div>}
      {!isActivitiesLoading && activities.length > 0 && <>
        {/* <div className="activities__filters">*/}
        {/*  <button className={`activities__filter-btn ${filter === 'all' ? 'active' : ''}`} onClick={() => setFilter('all')}>*/}
        {/*    <FormattedMessage*/}
        {/*      id={'gritx.activities.all'}*/}
        {/*      defaultMessage="All"*/}
        {/*    />*/}
        {/*  </button>*/}
        {/*  <button className={`activities__filter-btn ${filter === 'in_progress' ? 'active' : ''}`}*/}
        {/*    onClick={() => setFilter('in_progress')}>*/}
        {/*    <FormattedMessage*/}
        {/*      id={'gritx.activities.inProgress'}*/}
        {/*      defaultMessage="In progress"*/}
        {/*    />*/}
        {/*  </button>*/}
        {/*  <button className={`activities__filter-btn ${filter === 'completed' ? 'active' : ''}`}*/}
        {/*    onClick={() => setFilter('completed')}>*/}
        {/*    <FormattedMessage*/}
        {/*      id={'gritx.activities.completed'}*/}
        {/*      defaultMessage="Completed"*/}
        {/*    />*/}
        {/*  </button>*/}
        {/* </div>*/}

        <div className="activities__list">
          {filtered.map(a => (
            <ActivityCard key={a.xpeditionId} activity={a} />
          ))}
        </div>
      </>}
    </section>
  );
};
